<template>
	<v-layout row wrap fill-height class="team">
		<v-flex xs12 md3>
			<v-card>
				<v-list class="py-0" v-if="$vuetify.breakpoint.mdAndUp">
					<v-list-tile
						v-for="role in ROLES"
						:key="role.slug"
						:to="`/admin/roles/${role.slug}`"
					>{{role.name}}</v-list-tile>
				</v-list>

				<v-list v-else class="py-0">
					<v-list-group :value="listOpen" @click="listOpen = !listOpen">
						<v-list-tile slot="activator" class="decision-tree__category">
							<v-list-tile-content>
								<v-list-tile-title>All Roles</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile
							ripple
							v-for="role in ROLES"
							:key="role.slug"
							@click="listOpen = false"
							:to="`/admin/roles/${role.slug}`"
						>{{role.name}}</v-list-tile>
					</v-list-group>
				</v-list>
			</v-card>
		</v-flex>

		<v-flex xs12 md9>
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			listOpen: false
		};
	},

	props: {
		slug: {
			default: null
		}
	},

	computed: {
		...mapGetters("admin", {
			ROLES: "roles"
		}),

		isList() {
			return this.getObjectValue("slug", this) === null;
		},

		isSideBarList() {
			return this.$route.matched.length > 2;
		},

		mainListBindings() {
			return {
				[`xs${this.isSideBarList ? 12 : 8}`]: true
				// ['offset-xs1']: !this.isSideBarList,
				// [`order-xs2`]: this.isSideBarList
			};
		},

		sideBarBindings() {
			return {
				[`xs${this.isSideBarList ? 3 : 12}`]: true
				// ['offset-xs1']: !this.isSideBarList,
			};
		}
	},

	methods: {
		...mapActions("admin", {
			GET_ROLES: "getRoles"
		})
	},

	created() {
		this.GET_ROLES();
	}
};
</script>
